// SPDX-License-Identifier: Elastic-2.0
/**
 * Onboarding-state helper (T-004).
 *
 * Reads the localStorage `onboarding-complete` flag set at the end of
 * A6 (functional spec § 3.8). Returns `false` in non-browser
 * environments so SSR / test harnesses never accidentally treat a
 * blank user as onboarded.
 *
 * Used by both the React `OnboardingGuard` and the root-route loader
 * — kept in its own file so non-component callsites can import it
 * without dragging in JSX dependencies.
 */
export function isOnboardingComplete(): boolean {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return false;
  }
  return window.localStorage.getItem("onboarding-complete") === "true";
}
